'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('./button.cssm');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A simple button component based on an Anchor (<a>) Element. Pass
 */
var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Button)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props;
      var enabled = _this$props.enabled;
      var onClick = _this$props.onClick;


      if (!enabled || onClick) {
        // Make sure any href isn't followed if we're enabled or if an onClick
        // handler was provided (should override any href)
        e.preventDefault();
      }

      if (!enabled) {
        return;
      }

      if (onClick) {
        onClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var variant = _props.variant;
      var size = _props.size;
      var className = _props.className;
      var enabled = _props.enabled;
      var tabIndex = _props.tabIndex;

      var props = _objectWithoutProperties(_props, ['children', 'variant', 'size', 'className', 'enabled', 'tabIndex']);

      var classes = (0, _classnames2.default)(_button2.default['variant-' + variant], _button2.default['size-' + size], !enabled && _button2.default.disabled, 'ls-button', 'ls-button-' + variant, className);

      // When disabled, we don't set tabIndex, which prevents the button from
      // being keyboard-focusable.
      if (enabled) {
        props.tabIndex = tabIndex;
      }

      return _react2.default.createElement(
        'a',
        _extends({}, props, {
          className: classes,
          role: 'button',
          onClick: this.handleClick }),
        children
      );
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  children: _react.PropTypes.any,
  variant: _react.PropTypes.oneOf(['normal', 'blue', 'red']),
  size: _react.PropTypes.oneOf(['normal', 'small']),
  tabIndex: _react.PropTypes.number,
  className: _react.PropTypes.string,
  enabled: _react.PropTypes.bool,
  onClick: _react.PropTypes.func
};
Button.defaultProps = {
  variant: 'normal',
  size: 'normal',
  tabIndex: 0,
  enabled: true
};
exports.default = Button;
;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/button/button.js
// module id = 143
// module chunks = 0